import { render, staticRenderFns } from "./QueueFilterComponent.vue?vue&type=template&id=c123a28e&"
import script from "./QueueFilterComponent.vue?vue&type=script&lang=js&"
export * from "./QueueFilterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports